import { render, staticRenderFns } from "./appConfigList.vue?vue&type=template&id=0c5c5e34&scoped=true"
import script from "./appConfigList.vue?vue&type=script&lang=js"
export * from "./appConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c5e34",
  null
  
)

export default component.exports